module.exports = {"TXTMOB_My_Tickets":{"id":"TXTMOB_My_Tickets","defaultMessage":"Мои билеты"}}